import React from 'react'
import { Card, Flex } from 'antd'
import { PromptStyle } from '@pushly/models/lib/enums'
import { FormLayoutRow, Well } from '@pushly/aqe/lib/components'
import classNames from 'classnames'

type PromptTreatmentStyleSelectorProps = {
    loading?: boolean
    value?: PromptStyle
    onChange: (value: PromptStyle) => void
}

const DEFAULT_PROMPT_STYLE = PromptStyle.NATIVE

export const PromptStyleSelector: React.FC<PromptTreatmentStyleSelectorProps> = ({ loading, value, onChange }) => {
    const options: { value: PromptStyle; label: string }[] = [
        { value: PromptStyle.NATIVE, label: 'System Prompt' },
        { value: PromptStyle.SLIDE, label: 'Slide Prompt' },
        { value: PromptStyle.PUBLISHER_CUSTOM, label: 'Custom Prompt' },
    ]

    const selected = value ?? DEFAULT_PROMPT_STYLE

    return (
        <Well title="Style" hideFooter={true} mode="ghost" flush>
            <Flex gap={8} className="prompt-style-options">
                {options.map((opt) => {
                    const optClassNames: string[] = [`prompt-style-${opt.value.toLowerCase()}`]

                    if (opt.value === selected) {
                        optClassNames.push('selected')
                    }

                    return (
                        <Card key={opt.value} className={classNames(optClassNames)} onClick={() => onChange(opt.value)}>
                            <Card.Meta title={opt.label} />
                        </Card>
                    )
                })}
            </Flex>
        </Well>
    )
}
